/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [导入新增建档数据↗](http://yapi.yishou.com/project/128/interface/api/38575) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/importData`
 */
const importDataRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/importData",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["file"],
        properties: { file: { type: "file", description: "", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "importData",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入新增建档数据↗](http://yapi.yishou.com/project/128/interface/api/38575) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/importData`
 */
export const importData = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importDataRequestConfig, requestData), ...args);
};
importData.requestConfig = importDataRequestConfig;
/**
 * 接口 [导出模版↗](http://yapi.yishou.com/project/128/interface/api/38577) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/exportTemplate`
 */
const exportTemplateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/exportTemplate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", tag: "v7320" } }, tag: "v7320" },
    requestFunctionName: "exportTemplate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出模版↗](http://yapi.yishou.com/project/128/interface/api/38577) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/exportTemplate`
 */
export const exportTemplate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportTemplateRequestConfig, requestData), ...args);
};
exportTemplate.requestConfig = exportTemplateRequestConfig;
/**
 * 接口 [获取新建\/编辑下拉选项↗](http://yapi.yishou.com/project/128/interface/api/38579) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/getOps`
 */
const getOpsRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/getOps",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            floor: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: ["number", "string"], tag: "v7320" },
                        label: { type: ["string", "number"], tag: "v7320" },
                    },
                    required: ["value", "label"],
                    tag: "v7320",
                },
                tag: "v7320",
            },
            area: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        supply_area_id: { type: "string", tag: "v7320" },
                        supply_area: { type: "string", tag: "v7320" },
                    },
                    required: ["supply_area_id", "supply_area"],
                    tag: "v7320",
                },
                tag: "v7320",
            },
            cities: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number", tag: "v7320" }, label: { type: "string", tag: "v7320" } },
                    required: ["key", "label"],
                    tag: "v7320",
                },
                tag: "v7320",
            },
        },
        tag: "v7320",
    },
    requestFunctionName: "getOps",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取新建\/编辑下拉选项↗](http://yapi.yishou.com/project/128/interface/api/38579) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/getOps`
 */
export const getOps = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getOpsRequestConfig, requestData), ...args);
};
getOps.requestConfig = getOpsRequestConfig;
/**
 * 接口 [新增建档申请↗](http://yapi.yishou.com/project/128/interface/api/38581) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/add`
 */
const addRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/add",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "brand_name",
            "city",
            "market_id",
            "show_app",
            "floor",
            "area_id",
            "supplier_num",
            "avatar",
            "description",
        ],
        properties: {
            brand_name: { type: "string", description: "品牌名" },
            city: { type: "string", description: "城市di" },
            market_id: { type: "string", description: "二级市场id" },
            show_app: { type: "string", description: "是否可APP提前订阅:{1:是,2:否}" },
            floor: { type: "string", description: "楼层id" },
            area_id: { type: "string", description: "区域id" },
            supplier_num: { type: "string", description: "档口号" },
            avatar: { type: "string", description: "档口logo图片链接" },
            description: { type: "string", description: "档口简介" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "add",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新增建档申请↗](http://yapi.yishou.com/project/128/interface/api/38581) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/add`
 */
export const add = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(addRequestConfig, requestData), ...args);
};
add.requestConfig = addRequestConfig;
/**
 * 接口 [编辑商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/38583) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/edit`
 */
const editRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/edit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "sa_id",
            "brand_name",
            "city",
            "market_id",
            "show_app",
            "floor",
            "area_id",
            "supplier_num",
            "avatar",
            "description",
        ],
        properties: {
            sa_id: { type: "string", description: "建档id" },
            brand_name: { type: "string", description: "品牌名" },
            city: { type: "string", description: "城市id" },
            market_id: { type: "string", description: "二级市场id" },
            show_app: { type: "string", description: "是否可APP提前订阅:{1:是,2:否}" },
            floor: { type: "string", description: "楼层id" },
            area_id: { type: "string", description: "区域id" },
            supplier_num: { type: "string", description: "档口号" },
            avatar: { type: "string", description: "档口logo图片链接" },
            description: { type: "string", description: "档口简介" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "edit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [编辑商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/38583) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/edit`
 */
export const edit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editRequestConfig, requestData), ...args);
};
edit.requestConfig = editRequestConfig;
/**
 * 接口 [建档申请列表↗](http://yapi.yishou.com/project/128/interface/api/38585) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/listSupplyApply`
 */
const listSupplyApplyRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/listSupplyApply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["show_app", "fans_status"],
        properties: {
            show_app: { type: "string", description: "是否提前app订阅" },
            fans_status: { type: "string", description: "粉丝状态" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        mobile_phone: { type: "string" },
                        wechat_num: { type: "string" },
                        supply_id: { type: "string" },
                        status: { type: "string" },
                        market_id: { type: "string" },
                        floor: { type: "string" },
                        city: { type: "string" },
                        supplier_num: { type: "string" },
                        sa_id: { type: "string" },
                        area_id: { type: "string" },
                        apply_imgs: { type: "array", items: { type: "string" } },
                        submit_admin: { type: "string" },
                        submit_time: { type: "string" },
                        submit_reason: { type: "string" },
                        supply_name: { type: "string" },
                        subscribe_num: { type: "string", tag: "v7320", description: "粉丝数" },
                        brand_name: { type: "string" },
                        first_check_admin: { type: "string" },
                        first_check_time: { type: "string" },
                        second_check_admin: { type: "string" },
                        second_check_time: { type: "string" },
                        first_reject_reason: { type: "string" },
                        second_reject_reason: { type: "string" },
                        fans_status: { type: "string", tag: "v7320", description: "粉丝状态值（暂用不到）" },
                        show_app: { type: "string", tag: "v7320", description: "是否app提前订阅1是2否", mock: { mock: "2" } },
                        city_name: { type: "string" },
                        apply_status: { type: "string" },
                        fans_status_txt: {
                            type: "string",
                            tag: "v7320",
                            mock: { mock: "未转移为档口粉丝" },
                            description: "粉丝状态文字",
                        },
                        market_name: { type: "string" },
                        child_market_name: { type: "string" },
                        main_styles: { type: "string" },
                        submit_admin_name: { type: "string" },
                        first_check_admin_name: { type: "string" },
                        second_check_admin_name: { type: "string" },
                        apply_img: { type: "string" },
                    },
                    required: [
                        "mobile_phone",
                        "wechat_num",
                        "supply_id",
                        "status",
                        "market_id",
                        "floor",
                        "city",
                        "supplier_num",
                        "sa_id",
                        "area_id",
                        "apply_imgs",
                        "submit_admin",
                        "submit_time",
                        "submit_reason",
                        "supply_name",
                        "subscribe_num",
                        "brand_name",
                        "first_check_admin",
                        "first_check_time",
                        "second_check_admin",
                        "second_check_time",
                        "first_reject_reason",
                        "second_reject_reason",
                        "fans_status",
                        "show_app",
                        "city_name",
                        "apply_status",
                        "fans_status_txt",
                        "market_name",
                        "child_market_name",
                        "main_styles",
                        "submit_admin_name",
                        "first_check_admin_name",
                        "second_check_admin_name",
                        "apply_img",
                    ],
                },
            },
            pages: { type: "number" },
            styles: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            fans_status: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        key: { type: "number", tag: "v7320", description: "值" },
                        label: { type: "string", tag: "v7320", description: "文字" },
                    },
                    required: ["key", "label"],
                    tag: "v7320",
                },
                description: "粉丝状态选项",
                tag: "v7320",
            },
            show_app: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        key: { type: "number", tag: "v7320", description: "值" },
                        label: { type: "string", tag: "v7320", description: "文字" },
                    },
                    required: ["key", "label"],
                    tag: "v7320",
                },
                tag: "v7320",
                description: "是否app提前订阅选项",
            },
        },
    },
    requestFunctionName: "listSupplyApply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [建档申请列表↗](http://yapi.yishou.com/project/128/interface/api/38585) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/listSupplyApply`
 */
export const listSupplyApply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listSupplyApplyRequestConfig, requestData), ...args);
};
listSupplyApply.requestConfig = listSupplyApplyRequestConfig;
/**
 * 接口 [设置APP可提前订阅↗](http://yapi.yishou.com/project/128/interface/api/38595) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/setShowApp`
 */
const setShowAppRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/setShowApp",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sa_id", "show_app"],
        properties: {
            sa_id: { type: "string", description: "建档申请id" },
            show_app: { type: "string", description: "1是2否" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setShowApp",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置APP可提前订阅↗](http://yapi.yishou.com/project/128/interface/api/38595) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/setShowApp`
 */
export const setShowApp = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setShowAppRequestConfig, requestData), ...args);
};
setShowApp.requestConfig = setShowAppRequestConfig;
/**
 * 接口 [获取建档详情（用于编辑）↗](http://yapi.yishou.com/project/128/interface/api/38609) 的 **请求配置**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/detail`
 */
const detailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyApply/detail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["sa_id"], properties: { sa_id: { type: "string" } } },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            detail: {
                type: "object",
                properties: {
                    sa_id: { type: "string", tag: "v7320", description: "建档id" },
                    brand_name: { type: "string", tag: "v7320", description: "品牌名" },
                    city: { type: "string", tag: "v7320", description: "城市id" },
                    supply_id: { type: "string", tag: "v7320" },
                    subscribe_num: { type: "string", tag: "v7320", description: "订阅数" },
                    market_name: { type: "string", tag: "v7320" },
                    market_id: { type: "string", tag: "v7320", description: "子市场id" },
                    first_market_id: { type: "string", tag: "v7320", description: "一级市场id" },
                    show_app: { type: "string", tag: "v7320", description: "是否app提前订阅，1是2否" },
                    floor: { type: "string", tag: "v7320", description: "楼层" },
                    area_id: { type: "string", tag: "v7320", description: "区域id" },
                    supplier_num: { type: "string", tag: "v7320", description: "档口号" },
                    avatar: { type: "string", tag: "v7320", description: "logo" },
                    description: { type: "string", tag: "v7320", description: "简介" },
                },
            },
        },
    },
    requestFunctionName: "detail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取建档详情（用于编辑）↗](http://yapi.yishou.com/project/128/interface/api/38609) 的 **请求函数**
 *
 * @分类 [商家建档申请↗](http://yapi.yishou.com/project/128/interface/api/cat_3750)
 * @标签 `v7320`
 * @请求头 `POST /erp/SupplyApply/detail`
 */
export const detail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(detailRequestConfig, requestData), ...args);
};
detail.requestConfig = detailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/supplyApply3750.js